import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import apiFetchEdiRfidAuditDelete from '../../api/EdiRfidAuditDeleteAPI';
import { EDI_RFID_AUDIT_DELETE_REQUEST } from '../actions/types/EdiRfidAuditDeleteActionsTypes';
import { deleteEdiRfidAuditSuccessActionCreator, deleteEdiRfidAuditFailureActionCreator } from '../actions/EdiRfidAuditDeleteActions';
import { languageSelector } from '../../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../../locales/locales';

function* doEdiRfidAuditDeleteWorker(action) {
  const lang = yield select(languageSelector);

  try {
    const res = yield call(apiFetchEdiRfidAuditDelete, action.payload);
    yield put(deleteEdiRfidAuditSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.edirfidaudit.delete.success'),
    }));
  } catch (error) {
    yield put(deleteEdiRfidAuditFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'notification.edirfidaudit.delete.failure'),
    }));
  }
}

function* doEdiRfidAuditDeleteWatcher() {
  yield takeLatest(EDI_RFID_AUDIT_DELETE_REQUEST, doEdiRfidAuditDeleteWorker);
}

export default doEdiRfidAuditDeleteWatcher;
